import { ref } from 'vue'

// The Places level the project list is showing, for the map to mirror. Module-scope so
// PlaceBrowser (writer) and MapProjectBoundaries (reader) share it; null outside Location sort.
// Shape: { places: [{ key, name, count, target, geometry }], projectIds: number[] }
const placeMapLevel = ref(null)

export const usePlaceMapLevel = () => ({ placeMapLevel })
